<template>
  <el-dialog
    class="recharge-dialog"
    @close="closeDialog"
    title="新增充值申请"
    :visible="true"
    width="50%"
    center
  >
    <el-form
      :inline="true"
      :rules="rules"
      label-width="100px"
      ref="recharge"
      :model="formInline"
      class="demo-form-inline"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="充值前余额：">
            <el-input
              v-model="beforeBalance"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="RechargeAmount"
            label="充值金额："
          >
            <el-input
              type="text"
              v-model="formInline.RechargeAmount"
              placeholder="请输入充值金额"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充值后余额：">
            <el-input
              v-model="AfterBalance"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="SalesMan"
            label="当前销售："
          >
            <el-select
              v-model="formInline.SalesMan"
              placeholder="请选择销售"
            >
              <template v-for="item in  Salesman">
                <el-option
                  :label="item.name"
                  :value="item.id"
                  :key="item.UserId"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="PaymentAccount"
            label="打款账户："
          >
            <el-input
              v-model="formInline.PaymentAccount"
              placeholder="请输入打款账户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="PayDate"
            label="打款时间："
          >
            <el-date-picker
              v-model="formInline.PayDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择实际打款时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            prop="InvoiceType"
            label="发票类型："
          >
            <el-select
              v-model="formInline.InvoiceType"
              placeholder="请选择发票类型"
              @change="changeInvoiceType"
            >
              <el-option
                label="普通发票"
                :value="0"
              ></el-option>
              <el-option
                label="专用发票"
                :value="1"
              ></el-option>
              <el-option
                label="不开票"
                :value="2"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="CompanyName"
            label="企业名称："
            v-if="formInline.InvoiceType === 0 || formInline.InvoiceType === 1"
          >
            <el-input
              v-model="formInline.CompanyName"
              placeholder="请输入企业名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="TaxpayerIdentifNum"
            label="识别号："
            v-if="formInline.InvoiceType === 0 || formInline.InvoiceType === 1"
          >
            <el-input
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
              v-model="formInline.TaxpayerIdentifNum"
              placeholder="请输入识别号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="BranchBankInfo"
            label="开户行："
            v-if="formInline.InvoiceType === 0 || formInline.InvoiceType === 1"
          >
            <el-input
              v-model="formInline.BranchBankInfo"
              placeholder="请输入开户行"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="BankAccount"
            label="账号："
            v-if="formInline.InvoiceType === 0 || formInline.InvoiceType === 1"
          >
            <el-input
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
              v-model="formInline.BankAccount"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="LinkAddress"
            label="地址："
            v-if="formInline.InvoiceType === 0 || formInline.InvoiceType === 1"
          >
            <el-input
              v-model="formInline.LinkAddress"
              placeholder="请输入地址"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="上传打款凭证：">
            <el-input
              :disabled="true"
              v-model="formInline.PaymentVoucherPic"
            ></el-input>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button size="medium">选择文件</el-button>
            <span class="uploadTip">(请上传小于5M的图片)</span>
            <input
              type="file"
              ref="uploadFile"
              class="upload-file"
              @change="uploadFile"
            >
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="   ">
            <img
              :src="previewImg"
              alt=""
              class="preview-Img"
              @error="imgError"
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="closeDialog"
        size="small"
      >取 消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirmDialog('recharge')"
      >确 定</el-button>
    </span>
  </el-dialog>

</template>
<script>
import { uploadImg, GetSalesman, GetInvoiceTypeByUserId } from "api/advertiser";

export default {
  data() {
    var checkRechargeCount = (rule, value, callback) => {
      setTimeout(() => {
        if (isNaN(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("充值金额必须为≥0的数，请重新输入"));
          } else {
            if (value.split(".").length >= 2) {
              var num = value.split(".")[1].split("");
              if (num.length > 2) {
                callback(new Error("请保留两位小数"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          }
        }

        // }
      }, 100);
    };
    return {
      formInline: {
        RechargeAmount: "",
        InvoiceType: "",
        PaymentAccount: "",
        PaymentVoucherPic: "",
        SalesMan: "",
        PayDate: "",
        CompanyName: "",
        TaxpayerIdentifNum: "",
        BranchBankInfo: "",
        BankAccount: "",
        LinkAddress: ""
      },
      rules: {
        RechargeAmount: [
          { required: true, message: "充值金额不能为空！", trigger: "blur" },
          { validator: checkRechargeCount, trigger: "blur" }
        ],
        PaymentAccount: [
          { required: true, message: "打款账户不能为空！", trigger: "blur" }
        ],
        SalesMan: [
          { required: true, message: "请选择销售！", trigger: "change" }
        ],
        PayDate: [
          {
            required: true,
            message: "请选择实际打款时间！",
            trigger: "change"
          }
        ],
        InvoiceType: [
          { required: true, message: "请选择发票类型！", trigger: "change" }
        ],
        CompanyName: [
          { required: true, message: "企业名称不能为空！", trigger: "blur" }
        ],
        TaxpayerIdentifNum: [
          { required: true, message: "识别号不能为空！", trigger: "blur" }
        ],
        BranchBankInfo: [
          { required: true, message: "开户行不能为空！", trigger: "blur" }
        ],
        BankAccount: [
          { required: true, message: "账号不能为空！", trigger: "blur" }
        ],
        LinkAddress: [
          { required: true, message: "地址不能为空！", trigger: "blur" }
        ]
      },
      previewImg: "",
      Salesman: [],
      InvoiceInfo: []
    };
  },
  props: {
    rechargeInfo: Object
  },
  computed: {
    beforeBalance() {
      return this.rechargeInfo.AdsBalance.toFixed(2);
    },
    AfterBalance() {
      if (
        !this.formInline.RechargeAmount ||
        isNaN(this.formInline.RechargeAmount - 0)
      ) {
        return this.rechargeInfo.AdsBalance.toFixed(2);
      } else {
        return (
          this.rechargeInfo.AdsBalance +
          (this.formInline.RechargeAmount - 0)
        ).toFixed(2);
      }
    }
  },
  methods: {
    initData() {
      GetSalesman().then(res => {
        this.Salesman = Object.assign({}, this.Salesman, res.list);
      });
      GetInvoiceTypeByUserId({ UserId: this.rechargeInfo.UserId }).then(res => {
        if (res.status === 1) {
          if (res.result) {
            this.invoiceInfo = res.result;
          }
        }
      });
    },
    changeInvoiceType() {
      if (this.formInline.InvoiceType != 2) {
        this.formInline.CompanyName = "";
        this.formInline.TaxpayerIdentifNum = "";
        this.formInline.BranchBankInfo = "";
        this.formInline.BankAccount = "";
        this.formInline.LinkAddress = "";
        if (this.invoiceInfo.length > 0) {
          this.invoiceInfo.forEach(item => {
            if (item.InvoiceType === this.formInline.InvoiceType) {
              this.formInline.CompanyName = item.CompanyName;
              this.formInline.TaxpayerIdentifNum = item.TaxpayerIdentifNum;
              this.formInline.BranchBankInfo = item.BranchBankInfo;
              this.formInline.BankAccount = item.BankAccount;
              this.formInline.LinkAddress = item.LinkAddress;
            }
          });
        }
      }
    },
    closeDialog() {
      this.$emit("close");
    },
    confirmDialog(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.formInline.InvoiceType === 2) {
            this.formInline.CompanyName = "";
            this.formInline.TaxpayerIdentifNum = "";
            this.formInline.BranchBankInfo = "";
            this.formInline.BankAccount = "";
            this.formInline.LinkAddress = "";
          }
          var rechargeData = Object.assign({}, this.formInline);
          rechargeData.UserId = this.rechargeInfo.UserId;
          rechargeData.BeforeBalance = this.rechargeInfo.AdsBalance;
          rechargeData.AfterBalance = this.AfterBalance;
          this.$emit("close", rechargeData);
        } else {
          return false;
        }
      });
    },
    imgError() {
      this.previewImg = require("../../../common/img/b_img.png");
    },
    uploadFile(e) {
      var obj = e.target.files[0];
      var subName = obj.type.split("/");
      if ((obj.size > 5 * 1024) & (subName[0] != "image")) {
        this.$message({
          message: "请上传小于5M的图片。",
          type: "warning"
        });
        return false;
      }
      var fr = new FileReader();
      var that = this;
      fr.onload = function(e) {
        that.previewImg = e.target.result;
      };
      fr.readAsDataURL(obj);
      uploadImg(e.target.files[0]).then(res => {
        this.formInline.PaymentVoucherPic = res;
        this.$refs.uploadFile.value = "";
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";
.recharge-dialog {
  .el-dialog--center {
    .el-dialog__body {
      padding: 0;
      .el-row {
        border-top: 1px dashed #ececec;
        padding: 20px 20px 0;
        .el-form-item {
          margin-bottom: 15px;
          margin-right: 0;
          .el-select,
          .el-date-editor {
            width: 185px;
          }
          .el-button--medium {
            padding: 9px 20px;
          }
          .upload-file {
            opacity: 0;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            cursor: pointer;
          }
          .uploadTip {
            margin-left: 10px;
            color: #909090;
            font-size: 12px;
          }
          .preview-Img {
            display: block;
            width: 320px;
            margin: 10px auto 0;
          }
        }
      }
      p {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
      }
    }
    .dialog-footer {
      .el-button {
        width: 94px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/customer-management/recharge-dialog.vue